/* tslint:disable */
export var icon = "\n<svg width=\"31\" height=\"31\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.447 17.52l4.116 3.102-1.204 1.598-4.046-3.05a6 6 0 111.133-1.65zM14 19a4 4 0 100-8 4 4 0 000 8z\" fill=\"#3899EC\" fill-rule=\"evenodd\"/></svg>\n";
//# sourceMappingURL=thick-search.svg.js.map